export default __webpack_public_path__ + "static/media/list.119b5de0.jpg";